import { Euro, Award, Globe, School, Plane, Briefcase, Route, Home } from 'lucide-react';
import { WHY_ITALY } from '@/data/content';

const ICON_MAP = {
  euro: Euro, award: Award, globe: Globe, school: School,
  plane: Plane, briefcase: Briefcase, route: Route, home: Home,
};

const WhyItaly = () => {
  return (
    <section data-testid="why-italy-section">
      <div className="container">
        <div className="section-header">
          <div className="section-eyebrow">Why Italy</div>
          <h2 className="section-title">Italy is <span className="gold-gradient">Europe's Best Kept Secret</span></h2>
          <p className="section-subtitle">
            World-class education at zero tuition. Italy's public universities are some of the most prestigious in Europe — and they cost nothing for qualified international students.
          </p>
        </div>

        <div className="benefit-grid">
          {WHY_ITALY.map((item, i) => {
            const Icon = ICON_MAP[item.icon] || Award;
            return (
              <div key={i} className="benefit-card" data-testid={`why-italy-${i}`}>
                <div className="benefit-icon">
                  <Icon size={24} />
                </div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyItaly;
